import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import * as Msal from 'msal';
import { Router } from '@angular/router';
import { MsalUserService } from '../../applicationinfraestructure/services/msaluser.service';
import { AuthenticationService } from '../../applicationinfraestructure/services/authentication.service';
import { UsersData } from '../../applicationinfraestructure/interfaces/userData';
import { RegistroVentasService } from '../../registro/Services/registro-ventas.service';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { EmailVerificationComponent } from '../email-verification/email-verification.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html',
  styleUrls:['./login.component.css']
})
export class LoginComponent implements OnInit {

  mostrarLoginMarca = false;
  formLogin: FormGroup;

  constructor(private router: Router,
    private msalService: MsalUserService,
    private authService: AuthenticationService,
    private userData: UsersData,
    private registroServicios: RegistroVentasService,
    public readonly http: HttpClient,
    public dialog: MatDialog,
    private readonly formBuilder: FormBuilder) { 
      
    }

  ngOnInit(): void {
    this.construirFromularioLogin();
  }

  openModal(data:UsersData) {
    this.dialog.open(EmailVerificationComponent, {
      minWidth: '600px',
      width: '65vw',
      data:data
    });
  }

  construirFromularioLogin() {
    this.formLogin = this.formBuilder.group({
      usuario: ['', Validators.required],
      clave: ['', Validators.required]
    });
  }

  AutenticacionPactia() {
    sessionStorage.setItem("MarcaValido",'0');
    this.router.navigate(['/home']);
  }

  mostrarFormularioMarca() {
    this.mostrarLoginMarca = true;    
  }
  instagram() {              
    window.open("https://www.instagram.com/pactiaoficial/", "_blank");
  }

  whatsapp() {              
    window.open("https://api.whatsapp.com/send?phone=573102045050", "_blank");
  }

  linkedin() {              
    window.open("https://www.linkedin.com/company/pactia/", "_blank");
  }

  facebook() {              
    window.open("https://www.facebook.com/pactiaoficial", "_blank");
  }
  AutenticacionMarca() {
    //TODO: LLAMAR SERVICIO Y EN EL SUCCESS LLAMAR EL ROUTER.NAVIGATE,
    //ADICIONALMENTE SETEAR LAS VARIABLES DEL ENVIRONMENTE CON EL NOMBRE Y EL CORREO
    //ELECTRONICO Y GUARDAR EN EL SESSIONSTORAGE O EN LAS COOKIES UNA VARIABLE QUE IDENTIFIQUE
    //QUE EL USUARIO YA ESTA LOGUEADO.
    var usuario = this.formLogin.get('usuario').value;
    var clave = this.formLogin.get('clave').value;
    
    this.registroServicios.validarUsuarioMarca(usuario,clave).subscribe(
      resolve => {
        if (resolve != null) {
          environment.edificiosAutorizados = resolve.edificiosAutorizados;
          environment.marcasAutorizadas = resolve.marcasAutorizadas;
          environment.userEmailLogged = resolve.email;
          environment.userFullname = resolve.nombre;
          environment.tipoUsuario = resolve.tipoUsuario;
          sessionStorage.setItem("MarcaValido",'1');
          sessionStorage.setItem("userEmailLogged",resolve.email);
          if (resolve.emailVerificado == null) {
            this.openModal(resolve)
          }else{
            this.router.navigate(['/inicio'], {
              queryParams: {
                login: 'marca',
                tipoUsuario: resolve.tipoUsuario
              }
            }
            );
          }
        }
        else
        {
          Swal.fire({
            icon: 'error',
            title: 'Acceso Denegado...',
            text: 'Valide su usuario y contraseña'
          })
          
        }

      },
      (error: ErrorResponse) => {
        console.log(error);
      }
    );

 
  }
}
